import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IndividualPaymentDue } from "./payment-dues.entity";
import { getIndividualPaymentDues } from "./payment-dues.api";

interface PaymentDuesState {
  individualPaymentDues: IndividualPaymentDue[];
  loading: boolean;
  error: string | null;
}

const initialState: PaymentDuesState = {
  individualPaymentDues: [],
  loading: false,
  error: null,
};

export const fetchIndividualPaymentDues = createAsyncThunk(
  "paymentDues/fetchIndividual",
  async () => {
    return await getIndividualPaymentDues();
  }
);

const paymentDuesSlice = createSlice({
  name: "paymentDues",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchIndividualPaymentDues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndividualPaymentDues.fulfilled, (state, action) => {
        state.loading = false;
        state.individualPaymentDues = action.payload;
      })
      .addCase(fetchIndividualPaymentDues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to load individual payment dues";
      }),
});

export default paymentDuesSlice.reducer;





